<template>
  <div>
    <InfosCommercialMobile :showContact="showContact"/>
  </div>
</template>

<script>
import InfosCommercialMobile from './blocInfosMobile/InfosCommercialMobile';


export default {
  components: {
    InfosCommercialMobile,
  },
  data: () => ({
    showContact: true,
  }),
};
</script>

<style>

</style>